import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const ModalMenuState = atom({
    key: 'modalMenuState',
    default: false,
    // effects_UNSTABLE: [persistAtom],
})